import script from "./AIDisclosureNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./AIDisclosureNotice.vue?vue&type=script&setup=true&lang=js"

import "./AIDisclosureNotice.vue?vue&type=style&index=0&id=50dfc05e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50dfc05e"]])

export default __exports__